<template>
  <modal :modal-key="'unsubscribe_modal'"
         :class-style="'modal--welcomeback modal--unsubscribe'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ userDetails.username }}, {{ getTranslations.home_modals_unsubscribe_do_you_want }}</h1>
      <br>
      <p>{{ getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_unsub_unsubscribesms_modal')
      }}
    </template>
    <template slot="footer">
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'unsubscribe-sms',
  components: {
    Modal,
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/UnsubscribeSms.vue